<template>
  <div
    v-placeholder
    class="relative"
    @mouseover="onmouseover"
    @mouseleave="onmouseleave"
  >
    <div
      v-show="hover"
      v-if="noOverlay === false"
      class="
          hidden
          sm:block
          absolute
          top-0
          left-0
          z-10
          p-2
          bg-white
          rounded-md
          border
          border-gray-950
          shadow-2xl
          dark:bg-gray-800 min-w-[100px] max-w-[200px]
          overlay-component__overlay
        "
      :class="[overlayWrapClass]"
      :style="width ? `width: ${width}px` : ``"
    >
      <div class="overlay-component__placeholder" />
      <div class="mt-4 pointer-events-auto">
        <slot name="overlay-content" />
      </div>
    </div>
    <div
      :class="{'relative z-20': hover}"
      class="overlay-component__content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "OverlayComponent",
  directives: {
    placeholder: {
      mounted(el) {
        const placeholder = el.querySelector('.overlay-component__placeholder');

        if (placeholder) {
          placeholder.style.height = el.querySelector('.overlay-component__content').clientHeight + 'px';
        }
      },
      updated(el) {
        const placeholder = el.querySelector('.overlay-component__placeholder');

        if (placeholder) {
          placeholder.style.height = el.querySelector('.overlay-component__content').clientHeight + 'px';
        }
      }
    }
  },
  props: {
    noOverlay: {
      default: false,
      type: Boolean,
    },
    width: {
      default: null,
      type: Number,
    },
    overlayWrapClass: {
      default: 'z-10',
      type: String,
    }
  },

  emits: ["visible", "hidden"],

  data() {
    return {
      hoverTimeout: null,
      hover: false,
    };
  },
  methods: {
    onmouseover() {
      this.hover = true;
      this.$emit("visible");
    },
    onmouseleave() { 
      this.hover = false;
      this.$emit("hidden");
    },
  },
});
</script>

<style scoped>
.overlay-component__overlay {
  margin: calc(-0.5rem - 1px);
  width: calc(100% + 1rem + 1px);
}
</style>